import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { HomePeriodDays } from '../homePeriod';
import { SocialChannelRow } from './SocialChannelRow';
import { socialBlockMessages as messages } from './socialBlockMessages';
import { SocialSummaryChannel } from './socialSummaryTypes';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Social block; each part uses its own slice of it */
import styles from './SocialBlock.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialChannelRowsProps {
  channels: SocialSummaryChannel[];
  days: HomePeriodDays;
  onOpenChannels: () => void;
}

/** "Followers · last 28 days" and one row per channel, in the order the server gives (design d1). */
const SocialChannelRowsComponent: React.FC<SocialChannelRowsProps> = ({ channels, days, onOpenChannels }) => {
  const intl = useIntl();

  return (
    <div className={styles.column}>
      <div className={styles.key}>{intl.formatMessage(messages.followersPeriod, { days })}</div>
      <div className={styles.rows}>
        {channels.map((channel) => (
          <SocialChannelRow key={channel.platform} channel={channel} onOpen={onOpenChannels} />
        ))}
      </div>
    </div>
  );
};

export const SocialChannelRows = TypedMemo(SocialChannelRowsComponent);
